import CalmCoastLogo from "../Assets/CalmCoastNoBg.png";
import BlueSeas from "../Assets/Photos/Blue-Seas.jpeg";
import CarlyClinic1 from "../Assets/Photos/carly-clinic-1.jpg";
import CarlyInstructing from "../Assets/Photos/Carly-Instructing.jpeg";
import CarlyClinic3 from "../Assets/Photos/carly-clinic-3.jpg";
import YogaPhoto from "../Assets/Photos/Yoga-Wembury-Sauna-210326-123.jpg";
import Seo from "../Components/Seo";
import { Link } from "react-router-dom";
import { faFacebook, faInstagram } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Home() {
  const supportItems = [
    "Anxiety, stress, and feeling constantly 'on edge'",
    "Burnout - including modern life, parental and healthcare burnout",
    "Overwhelm and difficulty switching off",
    "Sleep problems and insomnia",
    "Low confidence and self-doubt",
    "Negative thought patterns and overthinking",
    "Emotional regulation and feeling stuck in 'survival mode'",
    "Habits you want to change or let go of",
    "Navigating life transitions or feeling loss",
    "Quitting smoking/vaping",
    "Fears and phobias"
  ];

  return (
    <div className="mx-auto max-w-6xl space-y-10 pb-10">
      <Seo
        title="Home"
        description="Solution focused hypnotherapy in Wembury, Plymouth, South Devon and South Hams, plus online support to ease anxiety, stress, burnout, overwhelm and self-doubt."
        keywords="hypnotherapy Plymouth, hypnotherapy South Devon, hypnotherapy South Hams, solution focused hypnotherapy Wembury, anxiety support Plymouth, stress support South Devon, burnout support South Hams"
        path="/"
      />
      <section className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-3">
          <p className="mb-3 text-sm font-semibold uppercase tracking-wide text-coastal-600">Welcome</p>
          <h1 className="font-roboto text-3xl font-semibold text-coastal-800 md:text-5xl">
            Solution focused hypnotherapy for those wanting to move forward with control, positivity and focus.
          </h1>
          <p className="mt-4 text-lg leading-relaxed text-slate-700">
            Quiet the anxiety, stress, overwhelm and self-doubt without having to revisit the past.
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <a href="/#contact" className="rounded-full bg-coastal-600 px-5 py-2.5 font-medium text-white hover:bg-coastal-700">
              Book consultation
            </a>
            <Link to="/investment" className="rounded-full border border-coastal-300 px-5 py-2.5 font-medium text-coastal-700 hover:bg-coastal-50">
              View investment
            </Link>
          </div>
        </div>
        <div className="flex items-center justify-center rounded-2xl bg-coastal-50 p-4 md:col-span-2">
          <img src={CalmCoastLogo} alt="Calm Coast Hypnotherapy logo" className="max-h-64 w-auto object-contain" />
        </div>
      </section>

      <section id="about-carly" className="grid gap-6 rounded-3xl bg-coastal-50 p-6 ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-2">
          <img
            src={CarlyClinic1}
            alt="Carly in her clinic"
            className="h-full min-h-[320px] w-full rounded-2xl object-cover"
            style={{ objectPosition: "10% center" }}
          />
        </div>
        <div className="md:col-span-3">
          <h2 className="font-roboto text-3xl font-semibold text-coastal-800">About Carly</h2>
          <div className="mt-4 space-y-4 text-slate-700">
            <p>
              Hello, I am Carly. I am a qualified solution-focused hypnotherapist with a deep-rooted background in
              healthcare, bringing a unique blend of clinical experience and holistic practice to my work. As a
              registered nurse within the NHS for nearly 15 years, I have specialised in neurosurgical and trauma
              intensive care, supporting patients and families through some of life&apos;s most challenging moments.
              This experience has given me a profound understanding of the brain, the nervous system, and the impact
              of stress and trauma on overall wellbeing.
            </p>
            <p>
              I am particularly passionate about supporting those experiencing burnout - especially parents and
              healthcare professionals - as well as anyone feeling overwhelmed by the pressures and pace of modern
              life. Having worked in high-intensity clinical environments and navigated the realities of family life
              myself, I understand how easy it is to become stuck in "survival mode," and how exhausting that can
              feel.
            </p>
            <p>
              My approach is grounded in neuroscience, helping you understand what is happening in your brain and body,
              why patterns of stress, anxiety, or overwhelm persist, and most importantly, how to shift them. Through
              hypnotherapy, I guide you to move beyond survival responses, regulate your nervous system, and create
              lasting, meaningful change.
            </p>
            <p>
              Alongside my nursing career, I am a trained 200-hour yoga teacher, trained in both Vinyasa and Yin yoga.
              I integrate the calming, restorative aspects of these practices into my work, supporting you to reconnect
              with your body, build resilience, and feel more balanced.
            </p>
            <p>
              As a mum of two girls, I understand first-hand the demands of juggling responsibilities and the
              importance of balance, compassion, and self-care. My work is grounded in empathy, safety, and trust,
              offering a supportive space where you can pause, reset, and move forward with greater clarity and
              confidence.
            </p>
            <p>
              Whether you are looking to recover from burnout, reduce anxiety, improve sleep, or break unhelpful
              patterns, I am here to guide you with a personalised, evidence-informed approach that honours both
              science and holistic wellbeing.
            </p>
          </div>
        </div>
      </section>

      <section id="about" className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-3">
          <h2 className="font-roboto text-3xl font-semibold text-coastal-800">About</h2>
          <div className="mt-4 space-y-4 text-slate-700">
            <p>
              Hypnotherapy is a gentle yet powerful approach that works with your mind to create positive, lasting
              change. It uses guided relaxation to help you enter a calm, focused state where your mind becomes more
              open to helpful suggestions and new ways of thinking.
            </p>
            <p>
              When we experience stress, anxiety, or overwhelm, our brains can become stuck in unhelpful patterns -
              often operating in "survival mode." Hypnotherapy helps to interrupt these patterns, allowing your nervous
              system to settle and creating space for healthier responses to take their place.
            </p>
            <p>
              Rather than losing control, you remain aware and in control throughout the process. It is a safe,
              collaborative experience where we work together to understand what has been holding you back and gently
              reframe it.
            </p>
            <p>
              Hypnotherapy can support a wide range of concerns, including anxiety, stress, burnout, sleep
              difficulties, confidence, and unwanted habits. By working at a deeper level of the mind, it helps you
              move forward with greater ease, clarity, and resilience.
            </p>
            <p>
              Each session is tailored to you, combining relaxation, focused attention, and evidence-informed
              techniques to support meaningful, sustainable change.
            </p>
            <p>Sessions are currently offered for adults aged 18 and over.</p>
            <p className="font-semibold text-coastal-700">We do not focus on the past... We focus on what is possible.</p>
          </div>
        </div>
        <div className="md:col-span-2">
          <img src={BlueSeas} alt="Calm clinic-inspired coastal space" className="h-full min-h-[280px] w-full rounded-2xl object-cover" />
        </div>
      </section>

      <section id="support" className="grid gap-6 rounded-3xl bg-coastal-50 p-6 ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-2">
          <img src={CarlyInstructing} alt="One-to-one hypnotherapy session" className="h-full min-h-[320px] w-full rounded-2xl object-cover" />
        </div>
        <div className="md:col-span-3">
          <h2 className="font-roboto text-3xl font-semibold text-coastal-800">What can I help with?</h2>
          <p className="mt-4 text-slate-700">I commonly support clients with:</p>
          <ul className="mt-4 grid gap-2 text-slate-700 md:grid-cols-2">
            {supportItems.map((item) => (
              <li key={item} className="rounded-xl bg-white px-3 py-2 ring-1 ring-coastal-100">
                {item}
              </li>
            ))}
          </ul>
          <p className="mt-5 text-slate-700">
            Whether you are feeling exhausted, anxious, or simply not like yourself, hypnotherapy offers a space to
            reset, regain control, and move forward with greater clarity and calm.
          </p>
        </div>
      </section>

      <section id="yoga-events" className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-3">
          <h2 className="font-roboto text-3xl font-semibold text-coastal-800">Yoga and events</h2>
          <p className="mt-4 leading-relaxed text-slate-700">
            Alongside my hypnotherapy work, I also offer yoga at Wembury Wild Sauna - a beautiful coastal space
            designed for rest, reset, and reconnection. These sessions combine gentle, accessible yoga with the deeply
            restorative benefits of sauna, supporting your nervous system to slow down and shift out of stress and into
            a place of calm. Set against the natural backdrop of the sea, it is an opportunity to step away from the
            demands of everyday life, reconnect with your body, and leave feeling grounded, relaxed, and rebalanced.
          </p>
          <a
            href="https://www.wemburywildsauna.co.uk/yoga"
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex rounded-full bg-coastal-600 px-5 py-2.5 font-medium text-white hover:bg-coastal-700"
          >
            Visit yoga and sauna events
          </a>
        </div>
        <div className="md:col-span-2">
          <img src={YogaPhoto} alt="Yoga session by the coast" className="h-full min-h-[280px] w-full rounded-2xl object-cover" />
        </div>
      </section>

      <section id="where" className="grid gap-6 rounded-3xl bg-white p-6 shadow-sm ring-1 ring-coastal-100 md:grid-cols-5">
        <div className="md:col-span-2">
          <img src={CarlyClinic3} alt="Interior of the Calm Coast caravan clinic in Wembury" className="h-full min-h-[320px] w-full rounded-2xl object-cover" />
        </div>
        <div className="md:col-span-3">
          <h2 className="font-roboto text-3xl font-semibold text-coastal-800">Where?</h2>
          <div className="mt-4 space-y-4 text-slate-700">
            <p>
              My converted caravan clinic offers a private and relaxing environment for hypnotherapy sessions, right
              here in Wembury. Designed to help you feel at ease, it is a friendly, welcoming space where you can
              focus on positive change and personal growth.
            </p>
            <p>
              For those who prefer the convenience of therapy from home, hypnotherapy can also be highly effective
              online. Many clients achieve excellent results through virtual sessions, benefiting from the comfort and
              familiarity of their own surroundings while receiving the same professional support and guidance.
            </p>
          </div>
        </div>
      </section>

      <section id="contact" className="rounded-3xl bg-coastal-800 p-6 text-white shadow-sm">
        <h2 className="font-roboto text-3xl font-semibold">Get in touch</h2>
        <p className="mt-1 text-coastal-100">
          Email: <a href="mailto:calmcoasthypnotherapy@hotmail.com" className="underline">calmcoasthypnotherapy@hotmail.com</a>
        </p>
        <p className="mt-1 text-coastal-100">
          Mobile: <a href="tel:07769943317" className="underline">07769943317</a>
        </p>
        <div className="mt-4 flex items-center gap-4">
          <a href="https://www.facebook.com/people/Calm-Coast-Hypnotherapy/61587439682200/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-coastal-700 px-3 py-2 text-coastal-100 hover:text-white">
            <FontAwesomeIcon icon={faFacebook} className="h-5 w-5" />
            Facebook
          </a>
          <a href="https://www.instagram.com/calm_coast_hypnotherapy/" target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-coastal-700 px-3 py-2 text-coastal-100 hover:text-white">
            <FontAwesomeIcon icon={faInstagram} className="h-5 w-5" />
            Instagram
          </a>
        </div>
        {/* <div className="mt-4 rounded-2xl bg-coastal-700/60 p-4 text-sm text-coastal-100">
          Insurance and NBH registration details: TBC for launch.
        </div> */}
      </section>
    </div>
  )
}